import * as React from 'react';
import { ICommissionBreakdownObject } from '../../../../data/entities/commission-breakdown';
import { IBookingBreakdown, IBookingV2 } from '../../../../data/entities/event/booking';
import { currencySymbolForCurrencyString } from '../../../../view/helpers/currency_helpers';
import { FormInputSymbol } from '../../form/form-input-symbol/FormInputSymbol';
import { Content } from '../../page/content/Content';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../table';
import { processCommissionBreakdown } from '../helpers';

export interface IProfitReportProps {
	booking: IBookingV2;
	commissionBreakdown: ICommissionBreakdownObject;
}

export const ProfitReport: React.FunctionComponent<IProfitReportProps> = (props) => {
	const currencySymbol = currencySymbolForCurrencyString(props.booking.value.currency);
	const breakdown = props.booking.value ? props.booking.value.breakdown : {} as IBookingBreakdown;
	const appliedPromotions = props.booking.owner_promotional_discounts || [];

	const promotionalCommissionAdjustment = processCommissionBreakdown(breakdown, props.commissionBreakdown, appliedPromotions);

	const commissionAdjustmentRateSum = promotionalCommissionAdjustment.reduce((accumulator, curr) => {
		if (curr.rate && breakdown.travelnest?.total_adjustment_commission_rate !== 0) {
			return accumulator + curr.rate;
		}
		return 0;
	}, 0);

	const commissionAdjustmentValueSum = promotionalCommissionAdjustment.reduce((accumulator, curr) => {
		if (curr.val && breakdown.travelnest?.total_adjustment_commission_rate !== 0) {
			return accumulator + curr.val;
		}
		return 0;
	}, 0);

	const incomeValue = breakdown?.travelnest?.income_value ?? 0;
	let channelValue = breakdown?.channel?.commission_net_value ?? 0;
	channelValue += commissionAdjustmentValueSum;

	const marginValue = incomeValue - channelValue;
	const marginRate = marginValue / incomeValue;

	return <Content type="full">
		<h2>Profit report</h2>
		<Table className="booking-breakdown-internal">
			<Thead>
				<Tr>
					<Th>Item</Th>
					<Th>%</Th>
					<Th>{currencySymbol}</Th>
					<Th></Th>
				</Tr>
			</Thead>
			<Tbody>
				<Tr>
					<Td className="booking-breakdown__table-cell--wide">Income value</Td>
					<Td />
					<Td className="booking-breakdown__table-cell--value">
						<FormInputSymbol
							symbol={currencySymbol}
							value={Number(breakdown.travelnest ? breakdown.travelnest.income_value || 0 : 0).toFixed(2)}
							readOnly={true}
						/>
					</Td>
					<Td />
				</Tr>
				<Tr>
					<Td>Channel commission net</Td>
					<Td className="booking-breakdown__table-cell--value">
						<FormInputSymbol
							symbol="%"
							position="after"
							value={Number(((breakdown.channel ? breakdown.channel.commission_rate || 0 : 0) + commissionAdjustmentRateSum) * 100).toFixed(1)}
							readOnly={true}
						/>
					</Td>
					<Td className="booking-breakdown__table-cell--value">
						<FormInputSymbol
							symbol={currencySymbol}
							value={(Number(breakdown.channel ? breakdown.channel.commission_net_value || 0 : 0) * -1 + (commissionAdjustmentValueSum * -1)).toFixed(2)}
							readOnly={true}
						/>
					</Td>
					<Td />
				</Tr>
				<Tr>
					<Td>Margin value</Td>
					<Td className="booking-breakdown__table-cell--value">
						<FormInputSymbol
							symbol="%"
							position="after"
							value={(marginRate * 100).toFixed(2)}
							readOnly={true}
						/>
					</Td>
					<Td className="booking-breakdown__table-cell--value">
						<FormInputSymbol
							symbol={currencySymbol}
							value={marginValue.toFixed(2)}
							readOnly={true}
						/>
					</Td>
					<Td />
				</Tr>
			</Tbody>
		</Table>
	</Content>;
};
